import * as buffer from "buffer";
(window as any).Buffer = buffer.Buffer;
